import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectContainWords = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('description_include')(jsonQuery),
);
